import { useMutation } from 'react-query';

import {
  FacilitateOrderData,
  MutationFunction,
  transformFacilitateData,
  useRequest,
} from '@frontend/api';

import type { Order } from './types';

export const getRefacilitateOrderKey = (params: { orderId: number }) =>
  ['orders', 'refacilitateOrder', params.orderId] as const;

export type RefacilitateOrderRequestData = Omit<
  FacilitateOrderData,
  | 'quoteNumber'
  | 'revisionNumber'
  | 'paymentMethod'
  | 'card'
  | 'stripeToken'
  | 'shippingRateToken'
> & {
  selectedOptionsList: {
    manualLeadtime: number | null;
    shipsOn: string | null;
  };
};

export const useRefacilitateOrder: MutationFunction<
  Order,
  RefacilitateOrderRequestData,
  [{ orderId: number }]
> = (params, { query, requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);
  const { orderId } = params;

  return useMutation(
    (data) => {
      const body = transformFacilitateData(data);
      return request(`/orders/${orderId}/refacilitate`, {
        query,
        init: {
          method: 'PUT',
          body,
        },
      });
    },
    {
      ...queryOptions,
      mutationKey: getRefacilitateOrderKey(params),
    },
  );
};
